import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7dd6389e")

_pushScopeId("data-v-7dd6389e")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("下载数据")
const _hoisted_5 = { style: {"display":"flex"} }
const _hoisted_6 = { class: "sticky-header" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode(_component_el_card, null, {
                default: _withId(() => [
                  _createVNode(_component_el_form, {
                    inline: true,
                    model: _ctx.generateReportVersion,
                    size: "mini"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "测试任务" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.task_record_id,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.task_record_id = $event)),
                            id: "new_version",
                            multiple: "",
                            onChange: _ctx.taskChange,
                            filterable: "",
                            "collapse-tags": "",
                            "collapse-tags-tooltip": "",
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.RecentTaskrecord, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "皮肤ID" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _ctx.skinChange,
                            modelValue: _ctx.skin_id,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.skin_id = $event)),
                            id: "new_version",
                            filterable: "",
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.skin_id_list, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item.chinese,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onChange", "modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"]),
                  _createVNode(_component_el_form, {
                    inline: true,
                    model: _ctx.generateReportVersion,
                    size: "mini"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "选择版本" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.game_version,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.game_version = $event)),
                            id: "new_version",
                            filterable: "",
                            key: _ctx.option_key,
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.skinReportOption.game_versions, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: index,
                                  label: item.date + item.game_version,
                                  value: item.game_version
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "选择机型" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.device,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.device = $event)),
                            id: "new_version",
                            filterable: "",
                            "collapse-tags": "",
                            "collapse-tags-tooltip": "",
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.skinReportOption.device_list, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.device_id,
                                  label: 
                    item.device_id__level +
                    '档机-' +
                    item.device_id__model__name +
                    '-' +
                    item.device_id__model
                  ,
                                  value: item.device_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "选择对比版本" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.game_version_old,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.game_version_old = $event)),
                            id: "new_version",
                            filterable: "",
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.skinReportOption_old.game_versions, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: index,
                                  label: item.date + item.game_version,
                                  value: item.game_version
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "选择对比指标" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.indicators,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.indicators = $event)),
                            id: "new_version",
                            multiple: "",
                            filterable: "",
                            "collapse-tags": "",
                            "collapse-tags-tooltip": "",
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_row, {
                                justify: "space-around",
                                type: "flex"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    class: "select-tag-class",
                                    style: {"width":"48%"},
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleSelectAll2('close')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_1
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    style: {"width":"48%"},
                                    class: "select-tag-class",
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleSelectAll2('open')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_2
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.skinReportOption.index_list, (item, k, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: index,
                                  label: item,
                                  value: k
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            onClick: _ctx.confirm,
                            type: "primary"
                          }, {
                            default: _withId(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            onClick: _ctx.exportExcel,
                            type: "primary"
                          }, {
                            default: _withId(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"]),
                  _createVNode("div", _hoisted_5, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fitstTable_new, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_table, {
                        id: item.title,
                        border: "",
                        size: "mini",
                        "header-cell-style": {
                background: '#5D99D5',
                color: '#fff',
              },
                        "span-method": _ctx.cellMerge,
                        key: index,
                        data: item.data
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_table_column, {
                            label: item.title
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, {
                                prop: "name",
                                label: "配置"
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "device",
                                label: "机型"
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "fps",
                                label: index === 0 ? 'minfps标准' : 'avgfps标准'
                              }, null, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                prop: "testNum",
                                label: "测试皮肤数"
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "passNum",
                                label: "合格皮肤数"
                              }),
                              _createVNode(_component_el_table_column, { label: "合格率" }, {
                                default: _withId((scope) => [
                                  _createTextVNode(_toDisplayString((scope.row.rate === 1 ? 1 : scope.row.rate.toFixed(2)) *
                        100 +
                      "%"), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["label"])
                        ]),
                        _: 2
                      }, 1032, ["id", "span-method", "data"]))
                    }), 128))
                  ]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.SkinReportData, (k, item, index) => {
                    return (_openBlock(), _createBlock(_component_el_table, {
                      border: "",
                      size: "mini",
                      "header-cell-style": {
              background: '#5D99D5',
              color: '#fff',
            },
                      ref: "table",
                      key: index,
                      data: k,
                      id: 'report-' + String(index)
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_table_column, { label: item }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.the, (v) => {
                              return (_openBlock(), _createBlock(_component_el_table_column, {
                                key: v,
                                label: v.name
                              }, {
                                header: _withId(() => [
                                  _createVNode("div", _hoisted_6, _toDisplayString(v.name), 1)
                                ]),
                                default: _withId((scope) => [
                                  _createVNode("span", null, _toDisplayString(scope.row[v.value]), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128)),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.thead, (v) => {
                              return (_openBlock(), _createBlock(_component_el_table_column, {
                                key: v,
                                label: v.name
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", null, _toDisplayString(scope.row[v.value] ? scope.row[v.value] : "-"), 1),
                                  (_ctx.filter_list.includes(v.value))
                                    ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.difference(scope.row, item, v.value, scope.row[v.value])), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128)),
                            _createVNode(_component_el_table_column, { label: "Perfdog" }, {
                              default: _withId((scope) => [
                                _createVNode("a", {
                                  href: _ctx.get_url(scope.row.Perfdog)
                                }, " 链接", 8, ["href"])
                              ]),
                              _: 1
                            }),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.thead1, (v) => {
                              return (_openBlock(), _createBlock(_component_el_table_column, {
                                key: v,
                                label: v.name
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(v.value, (x) => {
                                    return (_openBlock(), _createBlock(_component_el_table_column, {
                                      key: x,
                                      label: x.name
                                    }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(scope.row[x.value] ? scope.row[x.value] : "-"), 1),
                                        (_ctx.filter_list.includes(x.value))
                                          ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(_ctx.difference(scope.row, item, x.value, scope.row[x.value])), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["label"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["label"])
                      ]),
                      _: 2
                    }, 1032, ["data", "id"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})